import { render, staticRenderFns } from "./ConcurrentNode.vue?vue&type=template&id=24a784be&scoped=true"
import script from "./ConcurrentNode.vue?vue&type=script&lang=js"
export * from "./ConcurrentNode.vue?vue&type=script&lang=js"
import style0 from "./ConcurrentNode.vue?vue&type=style&index=0&id=24a784be&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24a784be",
  null
  
)

export default component.exports